import { Box } from "@mui/material";
import { GLItemDTO, GLItemKind, GLItemStatus } from "../../../DTO/GLItemDTO";
import { useState } from "react";
import LogChatMsg from "./LogChatMsg";

enum Status {
    idle,
    sending,
}
export default function LogChatCreateMsg({
    saveCB,
    personId,
    id,
}: {
    saveCB: () => void,
    personId?: number,
    id?: number,
}) {
    const [status, setStatus] = useState(Status.idle)
    const [item, setItem] = useState(new GLItemDTO({
        id: -1,
        kind: GLItemKind.generic,
        status: GLItemStatus.generic,
        personId,
        parentId: id && id > -1 ? id : undefined,
    }))
    function saveStart() {
        setStatus(Status.sending)
    }
    async function save() {
        
        setItem(new GLItemDTO({
            id: -1,
            kind: GLItemKind.generic,
            status: GLItemStatus.generic,
            personId,
            parentId: id && id > -1 ? id : undefined,
        }))
        saveCB()
        setStatus(Status.idle)
    }
    return <Box>
        {
            status !== Status.sending &&
            <LogChatMsg
                item={item}
                saveStart={saveStart}
                saveCB={save}
            />
        }
    </Box>
}
